import React from 'react'
import PropTypes from 'prop-types'

const ExternalCardItems = ({ onCardSelect = () => {}, selectedCardId, cards = [] }) => (
  <React.Fragment>
    {cards.map((element, index) => (
      <div
        className={`external-card-item ${selectedCardId === element.id ? 'selected' : ''}`}
        key={`${element.name}_${index}`}
        onClick={() => onCardSelect(element)}
      >
        <img className="external-card-item__image" src={element.logoImageUrl} />
        <span className="external-card-item__title">{element.name}</span>
      </div>
    ))}
  </React.Fragment>
)

ExternalCardItems.propTypes = {
  onCardSelect: PropTypes.func,
  selectedCardId: PropTypes.number,
  cards: PropTypes.array,
}

export default ExternalCardItems
